//-------------------------------------------------------------------------------------------------- Imports
import { Card, Col, Row } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { ResponsePaymentDetails } from "../../../types/common";
import moment from "moment";

//-------------------------------------------------------------------------------------------------- Interfaces
interface TableDetailsProps {
    details: ResponsePaymentDetails[];
};

//-------------------------------------------------------------------------------------------------- Component
const TableDetails = (props: TableDetailsProps) => {
    const { details } = props;
    const formatter = Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" });

    return (
        <Row style={styles.mainContainer}>
            <Col span={24}>
                <Card style={styles.cardStyle} bodyStyle={styles.cardBodyStyle}>
                    <Row>
                        <Col span={24} style={styles.headerTableContainer}>
                            <Row>
                                <Col span={12}>
                                    <b>Fecha</b>
                                </Col>
                                <Col span={12}>
                                    <b>Cantidad</b>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            {details.map((obj, index) => (
                                <Row
                                    key={index}
                                    style={(index + 1 !== details.length) ? styles.divider : undefined}>
                                    <Col span={12} style={styles.colStyle}>
                                        <span>
                                            {moment(obj.fecha_registro).format("DD/MM/YY")}
                                        </span>
                                    </Col>
                                    <Col span={12} style={styles.colStyle}>
                                        <span>
                                            {formatter.format(obj.importe_neto)}
                                        </span>
                                    </Col>
                                </Row>
                            ))}
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        display: "block",
        width: "100%",
    },
    cardStyle: {
        width: "100%",
        boxShadow: "0px 0px 8px #00000029",
    },
    cardBodyStyle: {
        padding: 10,
    },
    headerTableContainer: {
        padding: 10,
        borderRadius: 15,
        textAlign: "center",
        color: "#ffffff",
        backgroundColor: "#0055c2",
    },
    colStyle: {
        textAlign: "center",
        marginBottom: 10,
        marginTop: 10,
    },
    divider: {
        borderBottom: "1px solid #000000",
    }
});

//--------------------------------------------------------------------------------------------------
export default TableDetails;
